/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "../style/main.scss"
import {Footer} from "./footer";

const Layout = ({ children, headerImage, pageTitle }) => {
  useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div className={`body page-${(pageTitle || '').toLowerCase().replace(/[ ]/g, '-')}`}>
      <div id="outer-container">
        <Header headerImage={headerImage} pageTitle={pageTitle} />
        <div id="content-container">
          <div id="content-container-inner" className="clearfix">
            {children}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
